import React, { useEffect, useMemo, useRef, useState } from "react";
import "./css/LoginPage.css";
import logo from "../../img/elma.png";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
// import PremiumBackground from "../kuyumcu/components/PremiumBackground";

const LoginPage = () => {
  const [showCard, setShowCard] = useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [error, setError] = useState("");
  const [animateError, setAnimateError] = useState(false);
  const [errorKey, setErrorKey] = useState(0);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const userInputRef = useRef(null);

  const yearText = useMemo(() => new Date().getFullYear(), []);

  useEffect(() => {
    const t = setTimeout(() => setShowCard(true), 180);

    const rm = localStorage.getItem("rememberMe") === "1";
    const savedU = localStorage.getItem("rememberUsername") || "";

    setRememberMe(rm);
    if (rm && savedU) {
      setUsername(savedU);
    }

    const focusTimer = setTimeout(() => {
      userInputRef.current?.focus();
    }, 260);

    return () => {
      clearTimeout(t);
      clearTimeout(focusTimer);
    };
  }, []);

  const triggerError = (msg) => {
    setError(msg);
    setErrorKey((prev) => prev + 1);
    setAnimateError(true);

    setTimeout(() => {
      setAnimateError(false);
    }, 250);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setError("");

    const u = (username || "").trim();
    const p = password || "";

    if (!u || !p) {
      triggerError("Kullanıcı adı ve şifre boş olamaz!");
      return;
    }

    try {
      setLoading(true);

      const resp = await axiosInstance.post("/auth/login", {
        kullaniciAdi: u,
        password: p,
      });

      const data = resp?.data || {};

      if (!data.success) {
        triggerError(data.message || "Giriş başarısız.");
        return;
      }

      if (!data.token || !data.userId) {
        triggerError("Sunucudan eksik giriş bilgisi geldi.");
        return;
      }

      // Önce eski oturum izlerini temizle
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("uyelikTip");
      localStorage.removeItem("kuyumcuTipi");
      localStorage.removeItem("kullaniciAdi");
      localStorage.removeItem("firmaAdi");

      sessionStorage.removeItem("token");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("uyelikTip");
      sessionStorage.removeItem("kuyumcuTipi");
      sessionStorage.removeItem("kullaniciAdi");
      sessionStorage.removeItem("firmaAdi");

      // Tek kaynak: localStorage
      localStorage.setItem("token", String(data.token));
      localStorage.setItem("userId", String(data.userId));
      localStorage.setItem("uyelikTip", data.uyelikTip || "");
      localStorage.setItem("kuyumcuTipi", data.kuyumcuTipi || "");
      localStorage.setItem("kullaniciAdi", data.kullaniciAdi || u);
      localStorage.setItem("firmaAdi", data.firmaAdi || "");

      // Beni hatırla -> sadece kullanıcı adı
      localStorage.setItem("rememberMe", rememberMe ? "1" : "0");
      if (rememberMe) {
        localStorage.setItem("rememberUsername", u);
      } else {
        localStorage.removeItem("rememberUsername");
      }

      // PermissionProvider / auth dinleyen yerler için sinyal
      window.dispatchEvent(new Event("auth-changed"));

      navigate("/kuyumcu", { replace: true });
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data ||
        "Sunucuya bağlanılamadı.";
      triggerError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-bg" aria-hidden="true" />
{/*       <PremiumBackground /> */}

      <div className="login-grid">
        <aside className={`login-side ${showCard ? "show" : ""}`}>
          <div className="login-brand" onClick={() => navigate("/")}>
            <img src={logo} alt="Prosetwin Logo" className="login-logo" />
            <div className="login-brand-text">
              <div className="login-brand-title">Prosetwin</div>
              <div className="login-brand-subtitle">
                Atölye Kuyumcuları için muhasebe ve stok yönetimi
              </div>
            </div>
          </div>

          <div className="login-side-card">
            <div className="login-side-card-title">Hızlı ve güvenli giriş</div>

            <ul className="login-feature-list">
              <li>Firma bazlı çalışma (multi-tenant)</li>
              <li>Yetki sistemi ile kontrollü erişim</li>
              <li>Altın / Ziynet / Nakit / Stok akışları</li>
              <li>Log ve raporlama altyapısı</li>
            </ul>

            <div className="login-side-foot">
              <span>© {yearText} Prosetwin</span>
              <button
                type="button"
                className="login-link subtle"
                onClick={() => navigate("/")}
              >
                Ana sayfa
              </button>
            </div>
          </div>
        </aside>

        <section className="login-main">
          <div className={`login-card2 ${showCard ? "show" : ""}`}>
            <div className="login-card2-head">
              <div className="login-card-logo-wrap">
                <img
                  src={logo}
                  alt="Prosetwin Logo"
                  className="login-card-logo"
                />
              </div>
            </div>

            {error && (
              <div
                key={errorKey}
                className={`error-box2 ${animateError ? "shake" : ""}`}
                role="alert"
              >
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="login-form" autoComplete="on">
              <div className="field">
                <label>Kullanıcı Adı</label>
                <div className="field-control">
                  <FaUser className="field-icon" />
                  <input
                    ref={userInputRef}
                    type="text"
                    placeholder="Kullanıcı adınızı girin"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    autoComplete="username"
                    inputMode="text"
                  />
                </div>
              </div>

              <div className="field">
                <label>Şifre</label>
                <div className="field-control">
                  <FaLock className="field-icon" />
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Şifrenizi girin"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="toggle-password-btn"
                    onClick={() => setShowPassword((prev) => !prev)}
                    aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              <div className="login-row">
                <label className="remember2">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span>Beni hatırla</span>
                </label>

                <button
                  type="button"
                  className="login-link"
                  onClick={() => navigate("/register")}
                >
                  Hesabın yok mu? Kayıt ol
                </button>
              </div>

              <button type="submit" className="login-btn2" disabled={loading}>
                {loading ? (
                  <span className="btn-loading">
                    <span className="spinner" aria-hidden="true" />
                    Giriş yapılıyor...
                  </span>
                ) : (
                  "Giriş Yap"
                )}
              </button>

              <div className="login-hint">
                Sorun yaşıyorsanız kullanıcı adınızı kontrol edin veya sistem
                yöneticinize danışın.
              </div>
            </form>
          </div>
        </section>
      </div>
    </div>
  );
};

export default LoginPage;